<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Клиент</label>
        <crm-client-auto-complete
          [isError]="$any(errors?.client)"
          [(selectedClient)]="task.client"
          [showClear]="true"
          [customSearch]="false"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Дата прохода</label>
        <crm-datepicker
          [(value)]="task.date"
          [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        <small
          *ngIf="errors?.date"
          class="p-error">
          {{ errors?.date | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">ФИО гостя</label>
        <crm-input-text
          [(value)]="task.name"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>

      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteTask()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
